<template>
    <div>
      <h2>Select the shipping service that you would like to support</h2>
      <form @submit.prevent="submitForm">
        <div class="pl-4 inputs-cover">
          <div>
            <input type="checkbox" id="priorityShipping" value="Priority Shipping" v-model="selectedShippingOptions">
            <label for="priorityShipping">Priority Shipping</label>
          </div>
          <div>
            <input type="checkbox" id="standardShipping" value="Standard Shipping"  v-model="selectedShippingOptions">
            <label for="standardShipping">Standard Shipping</label>       
          </div>
          <div>
            <input type="checkbox" id="economyShipping" value="Economy Shipping" v-model="selectedShippingOptions">
            <label for="economyShipping">Economy Shipping</label>   
          </div>
        </div>
        <div class="box-cover pl-4 flex">
          <div class="color-box" :style="{ backgroundColor: isYellow ? '#FFA600' : '#FFFFFF' }"  @click="toggleBackgroundColor"></div>
          <p class="ml-2">Automatically show new services to customers when they become available</p>
        </div>
        <Actions />
      </form>
      <!-- <div v-if="selectedShippingOptions.length">
        <h3>Selected Shipping Options:</h3>
        <ul>
          <li v-for="option in selectedShippingOptions" :key="option">{{ option }}</li>
        </ul>
      </div> -->
    </div>
  </template>
    
  <script>
  import Actions from "@/components/EnterpriseCustomer/Settings/actions.vue";
  
  
  export default {
    name: 'ShippingOptions',
    components: {
          Actions,
      },
    data() {
      return {
        isYellow: false,
        selectedShippingOptions: []
      };
    },
    methods: {
      submitForm() {
      },
      toggleBackgroundColor() {
        this.isYellow = !this.isYellow;
      },
       back() {
        this.$router.go(-1)
      }
    }
  };
  </script>
  
  <style scoped>
  h2 {
    margin-left: 6%;
    margin-top: 5%;
  }
  form {
    margin-top: 6%;
  }
  
  .inputs-cover {
    width: 95%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 10%;
  }
  
  .color-box {
    width: 15px;
    height: 15px;
    border-radius: 15px;
    border: 1px solid #C5C4D4;
    cursor: pointer;
  }
  .box-cover{
    align-items: center;
  }
  .box-cover>p{
      color: rgba(20, 23, 31, 1);
      font-size: 14px;
      font-weight: 400;
    }
  </style>